import { render, staticRenderFns } from "./pointsStatistics.vue?vue&type=template&id=3da8d519&scoped=true"
import script from "./pointsStatistics.vue?vue&type=script&lang=js"
export * from "./pointsStatistics.vue?vue&type=script&lang=js"
import style0 from "./pointsStatistics.vue?vue&type=style&index=0&id=3da8d519&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8d519",
  null
  
)

component.options.__file = "pointsStatistics.vue"
export default component.exports